<template>
  <div class="container ">
    <div class="row">
      <div class="col-8 offset-2">
        <!-- Material form login -->
        <div class="card" v-if="submitted == false">

          <h5 class="card-header info-color white-text text-center py-4">
            <strong>Neues Passwort</strong>
          </h5>

          <!--Card content-->
          <div class="card-body px-lg-5 pt-0">

            <!-- Form -->
            <form class="text-center" style="color: #757575;"  @submit.prevent="reset" v-if="resetAllowed">

              <!-- Email -->
              <div class="md-form">
                <mdb-input type="password" v-model="password" label="Passwort"></mdb-input>
                <mdb-input type="password" v-model="password_confirm" label="Passwort wiederholen"></mdb-input>
              </div>

              <!-- Sign in button -->
              <mdb-btn color="primary">Passwort speichern</mdb-btn>

            </form>
            <h2 v-else>PasswortHash ist nicht mehr aktuell!</h2>
            <!-- Form -->

          </div>

        </div>
        <div class="card" v-else>

          <h5 class="card-header info-color white-text text-center py-4">
            <strong>Neues Passwort</strong>
          </h5>

          <!--Card content-->
          <div class="card-body px-lg-5">

            <h3 class="text-center">Vielen Dank. Ihr Passwort wurde zurückgesetzt.</h3>
            <router-link :to="{ name: 'home' }" class="navbar-brand">
              <div class="btn btn-outline-danger">Zum Login</div>
            </router-link>

          </div>

        </div>
        <!-- Material form login -->
      </div>
    </div>
  </div>

</template>

<script>
import mapActions from 'vuex'
import UserService from "@/services/UserService";
import EmailService from "@/services/EmailService";
import { mdbBtn, mdbInput, mdbDatePicker, mdbSelect, mdbSelectOption } from 'mdbvue';
export default {
  name: "Reset",
  components: {
    mdbBtn,
    mdbInput
  },
  data () {
    return {
      password: '',
      password_confirm: '',
      hash: "",
      resetAllowed: false,
      submitted: false,
    }
  },
  methods: {
    reset() {
      let pw = this.password;
      let pw_confirm = this.password_confirm;

      if(pw != "" && this.resetAllowed != false){
        if(pw === pw_confirm){
          let _this = this;
          UserService.resetPassword(this.hash, this.password).then(response => {

            this.$notify.success({
              position: 'top right',
              message: 'Passwort wurde gespeichert.',
              timeout: 3000
            });
            //TODO: SEND BESTÄTIGUNGS MAIL
            _this.submitted = true;
            EmailService.sendMail("PasswordResetSuccess", "Passwort zurückgesetzt", response.data[0].email);
          })

          .catch(error => {
            console.log("There was an error:", error.response);
          });
        } else {
          this.$notify.warn({
            position: 'top right',
            message: 'Passwörter stimmen nicht überein.',
            timeout: 3000
          });
        }
      } else {
        this.$notify.warn({
          position: 'top right',
          message: 'Bitte geben Sie ein Passwort ein.',
          timeout: 3000
        });
      }
    }

  },
  mounted() {
    this.hash = this.$route.query.rpHash;
    if(this.hash != "" && this.hash){
      this.resetAllowed = true;
    }
  }
};
</script>

<style scoped>

</style>
